angular.module('elfium').service('elfiumRelatedOptionsService', ['$q', 'companyService', 'contactService', 'taskService', 'elfiumRestService', 'TASK_TYPES', 'ELFIUM_USER_TYPES',
    function ($q, companyService, contactService, taskService, elfiumRestService, TASK_TYPES, ELFIUM_USER_TYPES) {
        var that = this;
        that.taskTypeOrder = [TASK_TYPES.POTREBA, TASK_TYPES.NABIDKA, TASK_TYPES.KUZAVRENI];
        that.getCompanyOptions = function () {
            var deferred = $q.defer();
            companyService.getCompanies().then(function (companies) {
                deferred.resolve(that._buildRelatedOptions(companies, 'id', ['nazev']));
            }, deferred.reject)
            return deferred.promise;
        };
        that.getUserOptions = function () {
            var deferred = $q.defer();
            var searchParameters = {
                type: ELFIUM_USER_TYPES.CONSULTANT
            };
            elfiumRestService.searchUsers(searchParameters).then(function (users) {
                deferred.resolve(that._buildRelatedOptions(users, 'id', ['name']));
            }, deferred.reject);
            return deferred.promise;
        };
        that.getBusinessCaseOptions = function () {
            var deferred = $q.defer();
            elfiumRestService.getBusinessCases().then(function (businessCases) {
                deferred.resolve(that._buildRelatedOptions(businessCases, 'id', ['nazev']));
            }, deferred.reject);
            return deferred.promise;
        };
        that.getContactOptionsForCompany = function (companyId) {
            var deferred = $q.defer();
            var searchParameters = {
                firmaId: companyId
            };
            contactService.searchContacts(searchParameters).then(function (contacts) {
                deferred.resolve(that._buildRelatedOptions(contacts, 'id', ['prijmeni', 'jmeno']));
            }, deferred.reject);
            return deferred.promise;
        };
        that.getContactOptionsForBusinessCase = function (businessCaseId) {
            var deferred = $q.defer();
            elfiumRestService.getBusinessCase(businessCaseId).then(function (businessCase) {
                var searchParameters = {
                    firmaId: businessCase.firmaId
                };
                contactService.searchContacts(searchParameters).then(function (contacts) {
                    deferred.resolve(that._buildRelatedOptions(contacts, 'id', ['prijmeni', 'jmeno']));
                }, deferred.reject);
            }, deferred.reject);
            return deferred.promise;
        };
        that._canAddRelatedOption = function (someObject) {
            return angular.isUndefined(someObject.aktivni) || someObject.aktivni;
        };
        that._buildRelatedOptions = function (objects, keyFieldName, valueFieldNames) {
            var relatedOptions = {};
            angular.forEach(objects, function (someObject) {
                if (that._canAddRelatedOption(someObject)) {
                    var objectOptionValues = [];
                    angular.forEach(valueFieldNames, function (valueFieldName) {
                        objectOptionValues.push(someObject[valueFieldName]);
                    });
                    relatedOptions[someObject[keyFieldName]] = objectOptionValues.join(' ');
                }
            });
            return relatedOptions;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumRelatedOptionsService.ts